import type { GqlClient } from '@/types/gqlClient'
import { graphql } from 'gql.tada'

const COPY_FILE_MUTATION = graphql(`
  mutation CopyProjectFile($projectId: Int!, $fileId: uuid!) {
    copyProjectFile(projectId: $projectId, fileId: $fileId) {
      id
      name
      size
      etag
    }
  }
`)

export type CopyFileResult = {
  id: number
  name: string
  size: number
  etag: string
}

export const copyFileViaAction = async (
  gqlClient: GqlClient,
  projectId: number,
  fileId: string
): Promise<CopyFileResult> => {
  const response = await gqlClient.request(COPY_FILE_MUTATION, {
    projectId,
    fileId,
  })
  if (!response.copyProjectFile) throw new Error('Failed to copy file')
  return response.copyProjectFile
}
